var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 28,
    viewBox: "0 0 22 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0002 14C9.5335 14 8.3335 12.8 8.3335 11.3333C8.3335 9.86663 9.5335 8.66663 11.0002 8.66663C12.4668 8.66663 13.6668 9.86663 13.6668 11.3333C13.6668 12.8 12.4668 14 11.0002 14ZM19.0002 11.6C19.0002 6.75996 15.4668 3.33329 11.0002 3.33329C6.5335 3.33329 3.00016 6.75996 3.00016 11.6C3.00016 14.72 5.60016 18.8533 11.0002 23.7866C16.4002 18.8533 19.0002 14.72 19.0002 11.6ZM11.0002 0.666626C16.6002 0.666626 21.6668 4.95996 21.6668 11.6C21.6668 16.0266 18.1068 21.2666 11.0002 27.3333C3.8935 21.2666 0.333496 16.0266 0.333496 11.6C0.333496 4.95996 5.40016 0.666626 11.0002 0.666626Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarker);
export default __webpack_public_path__ + "static/media/icon_marker.a03605a5f7a25b6d7deec6207f134e2b.svg";
export { ForwardRef as ReactComponent };